import { useEffect, useState } from 'react';
import PageTemplate from 'components/template/PageTemplate';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import { ReactComponent as Tab1 } from 'assets/solomonShip/tab1.svg'
import { ReactComponent as Tab2 } from 'assets/solomonShip/tab2.svg'
import { ReactComponent as Info } from 'assets/solomonShip/info.svg'
import { ReactComponent as Search } from 'assets/solomonShip/search.svg'
import Summary from 'components/solomonShip/tab/summary';
import ExportImportGuide from 'components/solomonShip/guide/exportImportGuide';
import LoadingGuide from 'components/solomonShip/guide/loadingGuide';
import HSOptimizer from 'components/solomonShip/guide/hSOptimizer';
import RiskManagement from 'components/solomonShip/guide/riskManagement';
import Documents from 'components/solomonShip/guide/documents';
import Chat from 'components/solomonShip/tab/chat';
import { jsonAxios } from 'components/axios';
import { ChatRoomList } from 'types/chat';
import { ReactComponent as CheckBoxOn } from 'assets/solomonShip/checkBoxOn.svg'
import { ReactComponent as CheckBoxOff } from 'assets/solomonShip/checkBoxOff.svg'
import { ReactComponent as Setting } from 'assets/solomonShip/setting.svg'
import { toast } from 'react-toastify';
import ReactMarkdown from "react-markdown";
import ImgModal from 'components/common/modal/ImgModal';
import { useNavigate } from 'react-router-dom';
import Quote from 'components/solomonShip/tab/quote';

const SlomonShip = () => {
    const navigate = useNavigate()
    const [chatId, setChatId] = useState<number>(-1);
    const [tab, setTab] = useState<number>(0);
    const tabMenu = [
        { id: 0, title: 'SolomonShip AI', icon: Tab1 },
        { id: 1, title: 'AI 견적 챗봇', icon: Tab2 },
        { id: 2, title: '채팅', icon: Tab2 },
    ];

    const [guide, setGuide] = useState<number>(-1);
    const guideMenu = [
        { id: 0, title: '수출입 가이드', },
        { id: 1, title: '적재 가이드' },
        { id: 2, title: 'HS Optimizer' },
        { id: 3, title: '리스크관리' },
        { id: 4, title: '문서/자료실' },
    ]

    const guideComponents: Record<number, JSX.Element> = {
        0: <ExportImportGuide />,
        1: <LoadingGuide />,
        2: <HSOptimizer />,
        3: <RiskManagement />,
        4: <Documents />,
    };

    const [search, setSearch] = useState<string>('');
    const [chatList, setChatList] = useState<ChatRoomList[]>([]);
    const [chatbotList, setChatbotList] = useState<ChatRoomList[]>([]);
    const [delList, setDelList] = useState<number[]>([])
    const [isSetting, setIsSetting] = useState<boolean>(false);
    const [imgPop, setImgPop] = useState<boolean>(false);
    const [imgUrl, setImgUrl] = useState<string>('');

    useEffect(() => {
        getChatList();
        getChatbotList();
    }, [])

    const getChatList = () => {
        // toast.info('준비중인 페이지 입니다.')
        // setTimeout(() => {
        //     navigate(-1)
        // }, 1000)


        jsonAxios.get('chat/rooms').then(res => {
            if (res.data.code === 200) {
                setChatList(res.data.data);
            }
        })
    }

    const getChatbotList = () => {
        jsonAxios.get('chatbot/rooms').then(res => {
            if (res.data.code === 200) {
                setChatbotList(res.data.data);
            }
        })
    }
    const tabComponents: Record<number, JSX.Element> = {
        0: <Summary />,
        1: <Quote
            chatId={chatId}
            setChatId={setChatId}
            getChatbotList={getChatbotList}
        />,
        2: <Chat
            chatId={chatId}
            setChatId={setChatId}
            getChatList={getChatList}
            setImgPop={setImgPop}
            setImgUrl={setImgUrl}
        />,
    };

    const delChat = () => {
        if (delList.length === 0) return
        const reqData = {
            roomIds: delList
        }
        jsonAxios.delete('chat/rooms', { data: reqData }).then(res => {
            if (res.data.code === 200) {
                setDelList([])
                setIsSetting(false)
                setChatId(-1)
                getChatList()
                toast.success('정상적으로 삭제 되었습니다.')
            }
            else {
                toast.error('오류가 발생했습니다.')
            }
        })
    }

    return (
        <PageTemplate background='bg-[#222222]' isFooter={false}>
            <div className='h-[calc(100dvh-64px)] text-white select-text'>
                <PanelGroup direction="horizontal">
                    <Panel defaultSize={15} minSize={15} maxSize={25}>
                        <div className='flex flex-col gap-3 py-10 pb-30 border-[#525252] border-r-1 h-full overflow-y-auto'>
                            {
                                tabMenu.map((item, idx) => {
                                    return (
                                        <div key={idx}>
                                            <div className={`flex justify-between items-center ${tab === item.id ? 'bg-[#303030] text-white' : 'text-[#525252]'} hover:bg-[#303030] hover:text-white transition-all cursor-pointer px-7 rounded`}>
                                                <div
                                                    className={`flex-1 shrink-0 flex items-center justify-start gap-3 h-15`}
                                                    onClick={() => {
                                                        setTab(item.id)
                                                        setIsSetting(false)
                                                        setGuide(-1)
                                                        setChatId(-1)
                                                    }}
                                                >
                                                    <item.icon className='shrink-0' fill={tab === item.id ? '#4AD35E' : '#525252'} />
                                                    <p>{item.title}</p>
                                                </div>
                                                {
                                                    idx === 2 &&
                                                    tab === 2 &&
                                                    chatList.length > 0 &&
                                                    <div
                                                        className='flex items-center h-full'
                                                        onClick={() => {
                                                            setIsSetting(p => !p)
                                                            setDelList([])
                                                        }}
                                                    >
                                                        <Setting />
                                                    </div>
                                                }
                                            </div>
                                            {
                                                idx === 1 &&
                                                chatbotList &&

                                                <div className='max-h-[310px] overflow-y-auto'>
                                                    {
                                                        chatbotList.map((item, idxs) => (
                                                            <div
                                                                className={`shrink-0 flex items-center justify-start gap-3 min-h-10 px-7 py-4 rounded transition-all cursor-pointer hover:bg-[#303030] hover:text-white ${(tab === 1 || tab === 3) ? chatId === item.id ? 'text-accent' : ' text-white' : 'text-[#525252]'}`}
                                                                key={idxs}
                                                                onClick={() => {
                                                                    setTab(1)
                                                                    setGuide(-1)
                                                                    setSearch('')
                                                                    setChatId(item.id)
                                                                }}
                                                            >
                                                                {
                                                                    isSetting &&
                                                                    <label
                                                                        htmlFor={`del${item.id}`}
                                                                        className='flex justify-between items-center gap-2 text-textGray mobile:text-sm text-lg cursor-pointer'
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                        }}
                                                                    >
                                                                        {
                                                                            delList.includes(item.id) ?
                                                                                <CheckBoxOn /> :
                                                                                <CheckBoxOff />
                                                                        }
                                                                        <input
                                                                            className="hidden accent-primary"
                                                                            type="checkbox"
                                                                            id={`del${item.id}`}
                                                                            checked={delList.includes(item.id)}
                                                                            onChange={(e) => {
                                                                                if (e.target.checked) {
                                                                                    // 체크되면 추가
                                                                                    setDelList((prev) => [...prev, item.id]);
                                                                                } else {
                                                                                    // 체크 해제되면 제거
                                                                                    setDelList((prev) => prev.filter((id) => id !== item.id));
                                                                                }
                                                                            }}
                                                                        />
                                                                    </label>
                                                                }
                                                                <ReactMarkdown>
                                                                    {item.title}
                                                                </ReactMarkdown>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            }
                                        </div>
                                    )
                                }
                                )
                            }
                            {
                                chatList &&
                                chatList.map((item, idx) => (
                                    <div
                                        className={`shrink-0 flex items-center justify-start gap-3 min-h-10 px-7 py-4 rounded transition-all cursor-pointer hover:bg-[#303030] hover:text-white ${tab === 2 ? chatId === item.id ? 'text-accent' : ' text-white' : 'text-[#525252]'}`}
                                        key={idx}
                                        onClick={() => {
                                            setTab(2)
                                            setGuide(-1)
                                            setSearch('')
                                            setChatId(item.id)
                                        }}
                                    >
                                        {
                                            isSetting &&
                                            <label
                                                htmlFor={`del${item.id}`}
                                                className='flex justify-between items-center gap-2 text-textGray mobile:text-sm text-lg cursor-pointer'
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                }}
                                            >
                                                {
                                                    delList.includes(item.id) ?
                                                        <CheckBoxOn /> :
                                                        <CheckBoxOff />
                                                }
                                                <input
                                                    className="hidden accent-primary"
                                                    type="checkbox"
                                                    id={`del${item.id}`}
                                                    checked={delList.includes(item.id)}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            // 체크되면 추가
                                                            setDelList((prev) => [...prev, item.id]);
                                                        } else {
                                                            // 체크 해제되면 제거
                                                            setDelList((prev) => prev.filter((id) => id !== item.id));
                                                        }
                                                    }}
                                                />
                                            </label>
                                        }
                                        <ReactMarkdown>
                                            {item.title}
                                        </ReactMarkdown>
                                    </div>
                                ))
                            }
                        </div>
                        {
                            isSetting &&
                            delList.length > 0 &&
                            <div className='bottom-6 z-50 sticky bg-[#222222] mx-auto px-10 py-2.5 border border-red rounded hover:text-red text-lg text-center transition-all cursor-pointer'
                                style={{
                                    width: 'calc(100% - 80px)'
                                }}
                                onClick={delChat}
                            >
                                채팅삭제
                            </div>
                        }
                    </Panel>
                    <PanelResizeHandle />
                    <Panel minSize={40}>
                        <div className='flex flex-col gap-10 p-10 border-[#525252] border-r-1 h-full overflow-y-auto'>
                            <div className='relative self-end bg-[#303030] pr-12 pl-6 rounded w-[390px] h-15 shrink-0'>
                                <input
                                    type="text"
                                    height={15}
                                    placeholder="검색"
                                    className='bg-transparent outline-none w-full h-full placeholder:text-[#525252]'
                                    value={search}
                                    onChange={(e) => {
                                        setSearch(e.target.value)
                                    }}
                                />
                                <div className='top-0 right-3 absolute flex justify-center items-center h-full cursor-pointer'>
                                    <Search fill='white' />
                                </div>
                            </div>
                            {tabComponents[tab]}
                            {guideComponents[guide]}
                        </div>
                    </Panel>
                    <PanelResizeHandle />
                    <Panel defaultSize={15} minSize={15} maxSize={25}>
                        <div className='flex flex-col gap-3 px-3 py-10 h-full overflow-y-auto'>
                            <div
                                className={`shrink-0 flex items-center justify-start gap-3 h-15 px-7 border border-[#525252] rounded transition-all cursor-pointer`} >
                                <Info className='shrink-0' />
                                <p>SolomonShip 가이드</p>
                            </div>
                            {
                                guideMenu.map((item, idx) => (
                                    <div
                                        className={`shrink-0 flex items-center justify-start gap-3 h-10 px-7 rounded transition-all cursor-pointer hover:bg-[#303030] ${guide === item.id ? 'bg-[#303030] text-accent' : 'text-[#525252]'}`}
                                        key={idx}
                                        onClick={() => {
                                            setGuide(item.id)
                                            setTab(-1)
                                        }}
                                    >
                                        <p>{item.title}</p>
                                    </div>
                                ))
                            }
                        </div>
                    </Panel>
                </PanelGroup>
            </div>
            <ImgModal
                isOpen={imgPop}
                setIsOpen={setImgPop}
                url={imgUrl}
            />

        </PageTemplate>
    )
}

export default SlomonShip